import React, { useEffect, useState } from "react";
import AccordionWrapper from "../../../reusableComponents/AccordionWrapper/AccordionWrapper";
import KeyboardArrowDownOutlinedIcon from "@mui/icons-material/KeyboardArrowDownOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { Tooltip, Typography } from "@mui/material";
import { formatDateWithoutTimezone, isEmpty } from "../../utils/utils";
import { useAuth } from "../../../context/API_Client";

function RuleDetail({ data, businessUnitOptions, paymentGateways }) {
  const [isOpen, setIsOpen] = useState(false);
  const [timeZone, setTimeZone] = useState("")
  const { merchantSettings } = useAuth()

  useEffect(() => {
    merchantSettings(
      function (data) {
        setTimeZone(data?.timeZone);
      },
      function (errorMsg) { }
    );
  }, [])

  return (
    <div>
      <AccordionWrapper isOpen={isOpen} initialHeight={120}>
        <div className="p-4">
          <div className="d-flex align-items-center justify-content-between">
            <div style={{ width: "30%" }}>
              <Typography className="labelRegular mb-2">
                Business Unit
              </Typography>
              <p className="ruleHeadingInfo ellipse-text ">
                {businessUnitOptions?.length
                  ? businessUnitOptions.find(
                    (el) => el.value == data?.legalEntityCode
                  )?.title
                  : data?.legalEntityCode}
              </p>
            </div>
            {data?.createdBy && <div style={{ width: "30%" }}>
              <Typography
                className="labelRegular mb-2"
                style={{
                  color: "var(--global-neutral-grey-1100, #2D2B32)",
                }}
              >
                Created By
              </Typography>

              <p className="ruleHeadingInfo ellipse-text ">{data?.createdBy}</p>
            </div>}
            {data?.updatedOn && <div style={{ width: "30%" }}>
              <Typography
                className="labelRegular mb-2"
                style={{
                  color: "var(--global-neutral-grey-1100, #2D2B32)",
                }}
              >
                Last Updated On
              </Typography>

              <p className="ruleHeadingInfo ellipse-text ">
                {formatDateWithoutTimezone(data?.updatedOn, timeZone)}

              </p>
            </div>}
          </div>

          {isOpen && (
            <>
              <hr />
              <div>
                <p className="ruleHeadingInfo  ">Routing Rule</p>

                {!isEmpty(data?.criteriaWithTitles?.conditions) &&
                  data?.criteriaWithTitles?.conditions.map(
                    (conditionData, index) => {
                      return (
                        <div
                          className="d-flex  align-items-center "
                          style={{ gap: 20 }}
                        >
                          <div style={{ width: "50px" }}>
                            <p
                              className="ruleConditionInfo   ellipse-text  my-1 "
                              style={{
                                color: index ? "#7F7D83" : "#403E9F",
                              }}
                            >
                              {index ? "And" : "For"}
                            </p>
                          </div>
                          <div style={{ width: "300px" }}>
                            <p className="ruleConditionInfo   ellipse-text  my-1 ">
                              {conditionData?.field?.title || ""}
                            </p>
                          </div>
                          <div style={{ width: "180px" }}>
                            <p
                              className="ruleConditionInfo   ellipse-text   my-1 "
                              style={{ color: "#7F7D83" }}
                            >
                              {conditionData?.operator?.title || ""}
                            </p>
                          </div>
                          <p className="ruleConditionInfo ellipse-text my-1">
                            {(() => {
                              const concatenatedValues =
                                !isEmpty(conditionData?.values) &&
                                  typeof conditionData?.values === "object"
                                  ? conditionData?.values
                                    .map((val, innerIndex) => `${val.title}`)
                                    .join(" or ")
                                  : "";

                              return (
                                <Tooltip
                                  title={concatenatedValues || "No values"}
                                >
                                  <span>{concatenatedValues}</span>
                                </Tooltip>
                              );
                            })()}
                          </p>
                        </div>
                      );
                    }
                  )}

                <div className="pspRuleContainer d-flex" style={{ gap: 20 }}>
                  <span
                    className="ruleConditionInfo "
                    style={{ color: "#403E9F" }}
                  >
                    Route To{" "}
                  </span>
                  {!isEmpty(data?.routeTo?.pspRoutingParameters) &&
                    !isEmpty(paymentGateways) &&
                    data?.routeTo?.pspRoutingParameters.map((psp) => {
                      const currentPsp = paymentGateways.find(
                        (el) => el.value == psp.pspCode
                      );
                      return (
                        <div
                          className="d-flex align-items-center"
                          style={{ gap: "10px" }}
                        >
                          {psp?.pspCode && (
                            <>
                              <img
                                width={15}
                                src={currentPsp?.logoUrl || ""}
                                alt={currentPsp?.title || psp?.pspCode}
                              />
                              <p className="ruleConditionInfo m-0">
                                {currentPsp.title}
                              </p>
                              <p
                                className="ruleConditionInfo m-0"
                                style={{ color: "#7F7D83" }}
                              >
                                {psp.percentage && <span> {psp.percentage} %</span>}
                              </p>
                            </>
                          )}
                        </div>
                      );
                    })}
                </div>

                {data?.dynamicRoutingFallback && (
                  <div
                    className="d-flex align-items-center mt-4"
                    style={{ gap: 10 }}
                  >
                    <CheckCircleIcon
                      style={{
                        color: "#403E9F",
                        fontSize: "20px",
                      }}
                    />
                    <p
                      className="ruleConditionInfo   ellipse-text  my-1 "
                      style={{
                        color: "#403E9F",
                      }}
                    >
                      Dynamic Routing as Fallback Enabled
                    </p>
                  </div>
                )}
              </div>
            </>
          )}
          <div
            onClick={() => {
              setIsOpen((state) => !state);
            }}
            style={{
              transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
              textAlign: "center",
              cursor: "pointer",
            }}
          >
            <KeyboardArrowDownOutlinedIcon
              sx={{ fontSize: "40px", color: "#7F7D83" }}
            />
          </div>
        </div>
      </AccordionWrapper>
    </div>
  );
}

export default RuleDetail;
